export default "__VITE_ASSET__CeFopNuv__"